import { render, staticRenderFns } from "./Gallery.vue?vue&type=template&id=8fead614&scoped=true&lang=pug"
import script from "./Gallery.vue?vue&type=script&lang=js"
export * from "./Gallery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fead614",
  null
  
)

export default component.exports